import { render } from "./PageJadwalWawancaraOrangTua.vue?vue&type=template&id=19e6a416"
import script from "./PageJadwalWawancaraOrangTua.vue?vue&type=script&lang=js"
export * from "./PageJadwalWawancaraOrangTua.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__